import { find, includes, pipe, prop, propSatisfies } from 'ramda'

/**
 * Determine if string is five digit number and therefore could potentially
 * be a zip code.
 *
 * @param {str} possibleZip string to check if five digit number
 */
export const isFiveDigitNumString = possibleZip => {
  return /^\s*([0-9]{5})\s*$/.test(possibleZip)
}

/**
 * Helper method for pulling out specific data properties
 * from the deeply nested Geocoding results.
 *
 * @param {object} selectedPlace A place object from Google Geocoding API
 */
export const getData = selectedPlace => {
  return (type, property) =>
    pipe(
      find(propSatisfies(includes(type), 'types')),
      prop(property || 'long_name'),
    )(selectedPlace)
}
